import React, { useEffect, useState } from 'react';
import { Snackbar } from '@mui/material';

/**
 *
 * @param {*} props
 * @param {string} message mensagem que sera exibida
 * @returns
 */
function TopScreenAlert(props) {
  const [open, setOpen] = useState(true);
  const [text, setText] = useState('');

  useEffect(() => {
    if (props.message) {
      setText(props.message);
    } else {
      setText('Erro ao submeter ação! Tente novamente.');
    }
  }, [props.message]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={open}
        onClose={handleClose}
        message={`${text}`}
        key="top center of screen alert"
      />
    </div>
  );
}

export default TopScreenAlert;
